import { I18n } from '@calendly/i18n'
import { PageHeader } from '@calendly/ui/components/page-header'
import { TitleText } from '@calendly/ui/components/typography'


export const NewHeader = () => (
  <PageHeader
    title={I18n.t('publisher.admin.billing.title')}
    eyebrow={(
      <TitleText variant="eyebrow">
        {I18n.t('publisher.admin.navigation.organization')}
      </TitleText>
    )}
  />
)
